import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vxe_radio_button = _resolveComponent("vxe-radio-button");
  return _openBlock(), _createBlock(_component_vxe_radio_button, _mergeProps(_ctx.$attrs, {
    "model-value": $props.value,
    title: $props.title,
    disabled: _ctx.disabled,
    readonly: _ctx.readonly,
    size: _ctx.size,
    strict: $props.strict,
    onChange: $setup.handleChanged
  }), {
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {}, () => [_createTextVNode(_toDisplayString($props.title), 1)])]),
    _: 3
  }, 16, ["model-value", "title", "disabled", "readonly", "size", "strict", "onChange"]);
}